<template>
  <div class="container">
    <app-header title="商家入驻"/>
    <div class="all">
      <div style="color: red" v-if="row.status==2">你的申请被拒绝，原因：{{row.reason}}</div>
      <div class="hint">商家入驻信息填写</div>
      <div class="title">1.基本信息</div>
      <div class="row">
        <span class="name">公司名称</span>
        <input class="value" v-model="row.companyName" placeholder="请填写公司名称"/>
      </div>
      <div class="row">
        <span class="name">联系人</span>
        <input class="value" v-model="row.name" placeholder="请填写联系人"/>
      </div>
      <div class="row">
        <span class="name">座机</span>
        <input class="value" v-model="row.tel" placeholder="请填写座机"/>
      </div>
      <div class="row">
        <span class="name">手机号码</span>
        <input class="value" v-model="row.phone" placeholder="请填写手机号码" maxlength="11" onkeyup="this.value=this.value.replace(/[^\d]/g,'')"/>
      </div>
      <div class="row">
        <span class="name">QQ</span>
        <input class="value" v-model="row.qq" placeholder="请填写QQ号码" onkeyup="this.value=this.value.replace(/[^\d]/g,'')"/>
      </div>
      <div class="row">
        <span class="name">公司地址</span>
        <input class="value" v-model="row.companyAddress" placeholder="请填写公司地址"/>
      </div>
      <div class="row">
        <span class="name">信用代码</span>
        <input class="value" v-model="row.code" placeholder="请填信用代码"/>
      </div>
      <div class="title">2.法人信息</div>
      <div class="row">
        <span class="name">姓名</span>
        <input class="value" v-model="row.username" placeholder="请填写姓名"/>
      </div>
      <div class="row">
        <span class="name">性别</span>
        <van-radio-group v-model="row.sex" direction="horizontal" style="margin-left: 10px;">
          <van-radio  :name="0" checked-color="red">男</van-radio>
          <van-radio  :name="1" checked-color="red">女</van-radio>
        </van-radio-group>
      </div>
      <div class="title">3.分类信息</div>
      <div class="supplierall">
        <span class="name">供应商类型</span>
        <div class="supplierA" @click="show = true">
          <!--<div class="suhint" v-if="!row.type">请选择</div>-->
          <div class="suhint">{{$enums.SupplyType[row.type]}}</div>
          <img src="@/assets/addgo.png" alt="" width="14px" height="14px">
        </div>
      </div>
      <!--供应商类型弹窗-->
      <van-popup v-model="show" round position="bottom" :style="{ height: '30%' }" >
        <div class="popup">
          <div class="close" @click="show = false">
            <img src="@/assets/close.png" alt="" width="14px">
          </div>
          <div class="type"  @click="select(0,'原厂')" :class="typeActive===0?'active':''">原厂</div>
          <div class="type"  @click="select(1,'代理商')" :class="typeActive===1?'active':''">代理商</div>
          <div class="type"  @click="select(2,'分销商')" :class="typeActive===2?'active':''">分销商</div>
        </div>
      </van-popup>

      <div class="supplierall">
        <span class="name">供应商分类</span>
        <div class="supplierA" @click="show2 = true">
          <!--<div class="suhint">{{typeName2||'请选择'}}</div>-->
          <!--<div class="suhint" v-if="row.typeTwo==''">请选择{{row.typeTwo}}</div>-->
          <div class="suhint">{{$enums.ProductType[row.typeTwo]}}</div>
          <img src="@/assets/addgo.png" alt="" width="14px" height="14px">
        </div>
      </div>
      <!--供应商分类弹窗-->
      <van-popup v-model="show2" round position="bottom" :style="{ height: '30%' }" >
        <div class="popup">
          <div class="close" @click="show2 = false">
            <img src="@/assets/close.png" alt="" width="14px">
          </div>
          <div class="type"  @click="select2(0,'电子元器件')" :class="typeThreeActive===0?'active':''">电子元器件</div>
          <div class="type"  @click="select2(1,'电子产品')" :class="typeThreeActive===1?'active':''">电子产品</div>
          <div class="type"  @click="select2(2,'其他产品')" :class="typeThreeActive===2?'active':''">其他产品</div>
        </div>
      </van-popup>

      <div class="supplierall">
        <span class="name">供应商子分类</span>
        <div class="supplierA" @click="show3 = true">
          <div class="suhint">{{typeName3||'请选择'}}</div>
          <img src="@/assets/addgo.png" alt="" width="14px" height="14px">
        </div>
      </div>
      <van-popup v-model="show3" position="bottom">
        <van-picker show-toolbar :columns="columns" @cancel="show3 = false" @confirm="onConfirm" @change="onChange" />
      </van-popup>
      <!-- <div class="row">
        <span class="name">联系方式</span>
        <input class="value" placeholder="请填写联系方式"/>
      </div> -->
      <div>
        <div class="name" style="margin-top: 15px;margin-bottom: 10px">经营范围</div>
        <textarea class="synopsis" v-model="row.business" placeholder="请填写(2000字以内)" maxlength="2000"></textarea>
      </div>
      <div>
        <div class="name" style="margin-top: 15px;margin-bottom: 10px">简介</div>
        <textarea class="synopsis" v-model="row.brief" placeholder="请填写(2000字以内)" maxlength="2000"></textarea>
      </div>
      <div class="title">4.营业执照</div>
      <van-uploader
        :max-count='1'
        :file-list="fileList"
        :after-read="afterRead"
        @delete='deleteImg'
      />
      <div class="title">{{$enums.SupplyUpload[row.typeTwo | 0]}}</div>
      <van-uploader
        :max-count='1'
        :file-list="fileList2"
        :after-read="afterRead2"
        @delete='deleteImg2'
      />
      <van-radio-group v-model="radio">
        <van-radio name="1" checked-color="red" class="deal">我已阅读并同意平台协议合同内容</van-radio>
      </van-radio-group>
      <div class="submit" @click="_saveShopApply">提交</div>


    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Uploader } from 'vant'
import { saveShopApply,getShopApply } from '@/api/mine/cnter.js'
import { uploadimage } from '@/api/file.js'
import { treeMenu } from '@/api/category'
Vue.use(Uploader)
export default {
  name: 'Index',
  data() {
    return {
      typeActive: '',
      typeThreeActive: '',

      show: false,
      show2: false,
      show3: false,
      radio: '',
      fileList: [],
      fileList2: [],
      fileList3: [],
      typeName: '',
      typeName2: '',
      typeName3: '',
      columns: [],
      menuTree: [],
      provinceList: [],
      cityList: [],
      countyList: [],
      uid: '',
      row: {
        companyName: '',
        tel: '',
        companyAddress: '',
        username: '',
        sex: 0,
        type: '',
        typeTwo: '',
        business: '',
        brief: '',
        image: '',
        code:'',
        file:''
      }
    }
  },
  created(){
    this.treeMenu()
    var user = localStorage.getItem("userInfo")
    if (user){
      user = JSON.parse(user)
      this.uid = user.id
      this.getShopApply(user.id)
    }

  },
  methods: {
    getShopApply(id){
      getShopApply({uid: id}).then(res=>{
        if (res.success){
          this.radio = '1'
          if (res.data.id) {
            this.typeName3 = res.data.typeThreeName
            this.fileList.push({url: res.data.image})
            this.fileList2.push({url: res.data.file})
            this.row = res.data
          }
        }
      })
    },
    treeMenu(){
      treeMenu({type: this.row.typeTwo?this.row.typeTwo:0}).then(res=>{
        if (res.success){
          this.menuTree = res.data.menuTree
          this.cityList = this.menuTree[0].children
          let citys = res.data.menuTree
          this.columns = [
            {
              values: citys,
              className: "column1"
            },
            {
              values: citys[0].children,
              className: "column2"
            },
            // {
            //   values: citys[0].children[0].children,
            //   className: "column3"
            // }
          ]
        }

      })
    },
    onConfirm(value) {
      const compact = arr => arr.filter(Boolean); // 三级联动 去除没值的，比如只有两级
      const result = compact(value);
      let str = "";  // 呈现页面显示  /xxx/xxx/xxx
      result.forEach(item => {
        if (!str){
          str = item.text;
        } else {
          str += "/" + item.text;
        }
      });
      this.typeName3 = str;
      this.show3 = false;

      const end = result[result.length - 1]; // 一般都是取最后一个id给后台的
      const id = end.id;
      const name = end.name;
      this.row.typeThree = id
      this.row.typeThreeName = name
    },
    onChange(picker, values, index) {

      let ColumnIndex = picker.getColumnIndex(index);
      console.log("第" + index + "列", "第" + ColumnIndex + "个");

      if (index == 0) {
        this.cityList = this.menuTree[ColumnIndex].children
        if (this.cityList.length > 0){
          picker.setColumnValues(1, this.cityList);
          picker.setColumnValues(2, this.cityList[0].children || []);
        } else{
          picker.setColumnValues(1, []);
          picker.setColumnValues(2, []);
        }
      }

      if (index == 1){
        this.countyList = this.cityList[ColumnIndex].children
        picker.setColumnValues(index + 1, this.countyList || []);
      }
    },
    // 新增免费入住
    _saveShopApply() {
      if (!this.row.companyName){
        this.$toast.fail('请填写公司名称');
        return;
      }
      if (!this.row.name){
        this.$toast.fail('请填写联系人');
        return;
      }
      if (!this.row.tel){
        this.$toast.fail('请填写座机');
        return;
      }
      if (!this.row.phone){
        this.$toast.fail('请填写手机号码');
        return;
      }
      if (!this.row.qq){
        this.$toast.fail('请填写QQ号码');
        return;
      }
      if (!this.row.companyAddress){
        this.$toast.fail('请填写公司地址');
        return;
      }
      if (!this.row.code){
        this.$toast.fail('请填信用代码');
        return;
      }
      if (!this.row.username){
        this.$toast.fail('请填写姓名');
        return;
      }
      if (this.row.sex===''){
        this.$toast.fail('请选择性别');
        return;
      }
      if (this.row.type===''){
        this.$toast.fail('请选择供应商类型');
        return;
      }
      if (this.row.typeTwo===''){
        this.$toast.fail('请选择供应商分类');
        return;
      }
      if (!this.row.typeThree){
        this.$toast.fail('请选择供应商子分类');
        return;
      }
      if (!this.row.image){
        this.$toast.fail('请上传营业执照');
        return;
      }
      if (!this.row.file && this.row.typeTwo==0){
        this.$toast.fail('请上传原厂证明');
        return;
      }
      if (!this.row.file && this.row.typeTwo==1){
        this.$toast.fail('请上传代理证明');
        return;
      }
      if (!this.radio){
        this.$toast.fail('请勾选协议');
        return;
      }
      // var user = JSON.parse(localStorage.getItem('userInfo'))
      // if(!user){
      //   this.$router.push("/login");
      // }
      this.row.uid = this.uid
      saveShopApply(this.row).then((res) => {
        if (res.success) {
          this.$toast.success('提交成功')
          setTimeout(() => {
            this.$router.go(-1)
          }, 1000)
        } else {
          this.$toast.fail(res.msg)
        }
      })
    },
    select(val, name) {
      this.show = false
      this.row.type = val
      this.typeName = name
      this.typeActive = val
    },
    select2(val, name) {
      this.show2 = false
      this.row.typeTwo = val
      this.typeName2 = name
      this.treeMenu()
      this.typeName3 = null
      this.row.typeThree = null
      this.row.typeThreeName = null
      this.typeThreeActive = val
    },
    afterRead(file) {
      uploadimage(file.file).then((res) => {
        if (res.success) {
          this.fileList.push({ url: res.data })
          this.row.image = res.data
        }
      })
    },
    // 删除图片
    deleteImg(e) {
      this.fileList.splice(0, 1)
    },
    afterRead2(file) {
      uploadimage(file.file).then((res) => {
        if (res.success) {
          this.fileList2.push({ url: res.data })
          this.row.file = res.data
        }
      })
    },
    // 删除图片
    deleteImg2(e) {
      this.fileList2.splice(0, 1)
    },
  }
}
</script>

<style lang="less" scoped>
  .container{
      .all{
        padding: 12px;
        .hint{
          padding: 3px;
          font-size:26px;
          font-family:PingFang SC;
          font-weight:bold;
          line-height:39px;
          color:rgba(51,51,51,1);
          text-shadow:0px 2px 0px rgba(212,212,212,1);
          opacity:1;
        }
        .title{
          font-size:18px;
          font-family:PingFang SC;
          font-weight:bold;
          line-height:39px;
          margin-top: 10px;
          color:rgba(51,51,51,1);
          opacity:1;
        }
        .row{
          display: flex;
          flex-direction: row;
          align-items: center;
          height: 50px;
          border-bottom: 1px solid #F3F3F3;
          .name{
            width:64px;
            line-height: 60px;
            margin-right: 15px;
          }
          .value{
            width:245px;
            height:40px;
            border:none;
            margin-left: 10px;
          }
        }
        .synopsis{
          width:90%;
          height:244px;
          background:rgba(255,255,255,1);
          border:1px solid rgba(243,243,243,1);
          opacity:1;
          border-radius:6px;
          padding: 10px;
        }
        .deal{
          font-size:13px;
          font-family:PingFang SC;
          font-weight:400;
          line-height:39px;
          color:rgba(93,98,130,1);
          opacity:1;
          margin-top: 25px;
        }
        .submit{
          width:98%;
          height:40px;
          background:linear-gradient(0deg,rgba(244,4,66,1) 0%,rgba(226,23,75,0.73) 100%);
          opacity:1;
          border-radius:4px;
          margin-left: 1%;
          font-size:16px;
          font-family:PingFang SC;
          font-weight:400;
          line-height:40px;
          text-align: center;
          color:rgba(255,255,255,1);
          margin-top: 26px;
          margin-bottom: 50px;
        }
        .supplierall{
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          height: 50px;
          /*border-bottom: 1px solid #F3F3F3;*/
          .supplierA{
            width: 70%;
            display: flex;
            justify-content: space-between;
            .suhint{
              font-size:16px;
              font-family:PingFang SC;
              font-weight:400;
              opacity:1;
              margin-left: 10px;
            }
          }
          .deadd{
            color: #C9C9C9;
            font-size: 20px;
          }
        }
        .popup{
          .close{
            color: #C7C7C7;
            font-size: 30px;
            padding: 15px;
          }
          .type{
            height: 45px;
            line-height: 45px;
            border-top: 1px solid #DDDDDD;
            font-size:14px;
            font-family:PingFang SC;
            font-weight:400;
            color:rgba(51,51,51,1);
            opacity:1;
            text-align: center;
          }
          .active{
            color:rgba(254,0,59,1)!important;
          }
        }
      }
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/enter/apply.vue